// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ScrollArea_scrollbar__kDL70","thumb":"ScrollArea_thumb__Uxfdz"};